import { Redirect } from "react-router-dom";

import { useEventDefs } from "@/api/useEventDefs";
import useAccountMetadata from "@/hooks/useAccountMetadata";

function EntryPage() {
  const { data: events = [], isLoading: eventsLoading } = useEventDefs();
  const accountMetadata = useAccountMetadata();

  if (eventsLoading || !accountMetadata.loaded) {
    return null;
  }

  if (events.length === 0) {
    return <Redirect to={{ pathname: "/events/library" }} />;
  }

  return <Redirect to={{ pathname: "/insights" }} />;
}

export default EntryPage;
